import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import {AppNgAppkitModule} from '../app-ng-appkit.module';
import { AutoTagProcessComponent } from './components/auto-tag-process/auto-tag-process.component';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { F1118SchdCComponent } from './components/f1118-schd-c/f1118-schd-c.component';
import { PshipPtrComponent } from './components/pship-ptr/pship-ptr.component';
import { RdSalesAdjustmentComponent } from './components/rd-sales-adjustment/rd-sales-adjustment.component';
import { RdSalesAdjPercentageEditComponent } from './components/system-settings-ftc/rd-sales-adj-percentage-edit/rd-sales-adj-percentage-edit.component';
import { Config861EditComponent } from './components/system-settings-ftc/config-861-edit/config-861-edit.component';
import { FirEditGtapsAttributesComponent } from './components/fir-edit-gtaps-attributes/fir-edit-gtaps-attributes.component';
import { FirEditGtapsAttributesService } from './components/fir-edit-gtaps-attributes/fir-edit-gtaps-attributes.service';
import { FirFdiiQbaiExcludeAcctComponent } from './components/fir-fdii-qbai-exclude-acct/fir-fdii-qbai-exclude-acct.component';
import { BeatTypeConsolAddComponent } from './components/beat-details/beat-type-consol-add.component';
import { HtkoConfigComponent } from './components/system-settings-ftc/htko-config/htko-config.component';
import { Form1118ConfigComponent } from './components/form-1118-config/form-1118-config.component';
import { K2K3SyncConfigComponent } from './components/system-settings-ftc/ftc-sync-config/k2-k3-sync-config.component';
import { K2SyncComponent } from './components/k2-sync/k2-sync.component';
import { RdExpContributedComponent } from './components/rd-exp-contributed/rd-exp-contributed.component';
import { IntExpContributedComponent } from './components/int-exp-contributed/int-exp-contributed.component';
import { CfcInvestmentAdjEditComponent } from './components/cfc-investment-adj-edit/cfc-investment-adj-edit.component';
import { CfcSplitOnOwnerPercentEditComponent } from './components/cfc-split-on-owner-percent-edit/cfc-split-on-owner-percent-edit.component';
import { Form1118SyncComponent } from './components/form-1118-sync/form-1118-sync.component';
import { BranchTaxCreditableEditComponent } from './components/branch-tax-creditable-edit/branch-tax-creditable-edit.component';
import { BranchTaxCreditableAddComponent } from './components/branch-tax-creditable-add/branch-tax-creditable-add.component';
import { BranchTaxCreditableAddService } from './components/branch-tax-creditable-add/branch-tax-creditable-add.service';
import { BranchAndWithholdCommentComponent } from './components/branch-and-withhold-comment/branch-and-withhold-comment.component';
import { BranchtaxSummaryInfoComponent } from './components/branchtax-summary-info/branchtax-summary-info.component';
import { FtCommentsComponent } from './components/ftc-comments/ftc-comments.component';
import { InvestmentValidationComponent } from './components/investment-validation/investment-validation.component';
import { InvestmentValidationService } from './components/investment-validation/investment-validation.service';
import { SourcingAssetAdjustmentComponent } from './components/sourcing-asset-adjustment/sourcing-asset-adjustment.component';
import { TrackUntrackSchLComponent } from './components/track-untrack-sch-l/track-untrack-sch-l.component';
import { Form1118FtcEditComponent } from './components/form-1118-ftc-edit/form-1118-ftc-edit.component';
import { F1118HpIIAttachSchdComponent } from './components/f1118-hp-ii-attach-schd/f1118-hp-ii-attach-schd.component';
import { F1118AttachSchdComponent } from './components/f1118-attach-schd/f1118-attach-schd.component';
import { MeSicAssignmentComponent } from './components/me-sic-assignment/me-sic-assignment.component';
import { ExpenseTransAddEditComponent } from './components/expense-trans-add-edit/expense-trans-add-edit.component';
import { ExpenseTransAccountDetailsComponent } from './components/expense-trans-account-details/expense-trans-account-details.component';
import { ExpenseTransInfoComponent } from './components/expense-trans-info/expense-trans-info.component';
import { AttributeSetUpInfoComponent } from './components/attribute-set-up-info/attribute-set-up-info.component';
import { ExpenseConsolConfigComponent } from './components/expense-consol-config/expense-consol-config.component';
import { FtcDocumentationComponent } from './components/ftc-documentation/ftc-documentation.component';
import { FtcDocumentationService } from './components/ftc-documentation/ftc-documentation.service';
import { AssetRolloverComponent } from './components/asset-rollover/asset-rollover.component';
import { AssetRolloverService } from './components/asset-rollover/asset-rollover.service';
import { ExamsRolloverComponent } from './components/exams-rollover/exams-rollover.component';
import { Form1118SchdJComponent } from './components/form-1118-schd-j/form-1118-schd-j.component';
import { Form1118SchdJService } from './components/form-1118-schd-j/form-1118-schd-j.service';
import { Form1118SchdKComponent } from './components/form-1118-schd-k/form-1118-schd-k.component';
import { Form1118SchdKService } from './components/form-1118-schd-k/form-1118-schd-k.service';
import { ComponentDefaultsRolloverComponent } from './components/component-defaults-rollover/component-defaults-rollover.component';
import { ComponentDefaultsRolloverService } from './components/component-defaults-rollover/component-defaults-rollover.service';
import { OtherOverridesDeleteComponent } from './components/other-overrides-delete/other-overrides-delete.component';
import { OtherOverridesBatchDeleteComponent } from './components/other-overrides-delete/other-overrides-batch-delete.component';
import { F1065K2Module } from './components/F1065-K2/f1065-k2.module';
import { TransCatgSyncComponent } from './components/trans-catg-sync/trans-catg-sync.component';
import { WithholdTaxSummaryEditComponent } from './components/withhold-tax-summary-edit/withhold-tax-summary-edit.component';
import { AddAttachmentsComponent } from './components/add-attachments/add-attachments.component';
import { RemoveAttachmentsComponent } from './components/remove-attachments/remove-attachments.component';
import { K3OverridesComponent } from './components/k3-overrides/k3-overrides.component';
import { K3OverridesService } from './components/k3-overrides/k3-overrides.service';
import { ActSyncFtcComponent } from './components/act-sync-ftc/act-sync-ftc.component';
import { ActSyncFtcService } from './components/act-sync-ftc/act-sync-ftc.service';
import { TagSourcingComponent } from './components/tag-sourcing/tag-sourcing.component';
import { TagSourcingService } from './components/tag-sourcing/tag-sourcing.service';
import { TbbsReclassComponent } from './components/tbbs-reclass/tbbs-reclass.component';
import { TbbsReclassService } from './components/tbbs-reclass/tbbs-reclass.service';
import { FtcQar2018Component } from './components/ftc-qar2018/ftc-qar2018.component';
import { FtcSourcingSummaryComponent } from './components/ftc-sourcing-summary/ftc-sourcing-summary.component';
import { FtcSourcingSummaryService } from './components/ftc-sourcing-summary/ftc-sourcing-summary.service';
import { BranchTaxDefaultsEditComponent } from './components/branch-tax-defaults-edit/branch-tax-defaults-edit.component';
import { BranchTaxDefaultsEditService } from './components/branch-tax-defaults-edit/branch-tax-defaults-edit.service';
import { AttributeBatchComponent } from './components/attribute-batch/attribute-batch.component';
import { AddNewTagComponent } from './components/add-new-tag/add-new-tag.component';
import { ComponentDefaultsLockUnlockComponent } from './components/component-defaults-lock-unlock/component-defaults-lock-unlock.component';
import { ComponentDefaultsEditComponent } from './components/component-defaults-edit/component-defaults-edit.component';
import { FtcAttributeEditComponent } from './components/ftc-attribute-edit/ftc-attribute-edit.component';
import { FtcAttributeLockUnlockComponent } from './components/ftc-attribute-lock-unlock/ftc-attribute-lock-unlock.component';
import { SyncProcessComponent } from './components/sync-process/sync-process.component';
import { TransJobsComponent } from './components/trans-jobs/trans-jobs.component';
import { CoaDiagnosticFixComponent } from './components/coa-diagnostic-fix/coa-diagnostic-fix.component';

@NgModule({ declarations: [
        F1118SchdCComponent,
        PshipPtrComponent,
        RdSalesAdjustmentComponent,
        RdSalesAdjPercentageEditComponent,
        Config861EditComponent,
        FirEditGtapsAttributesComponent,
        FirFdiiQbaiExcludeAcctComponent,
        BeatTypeConsolAddComponent,
        Form1118ConfigComponent,
        RdExpContributedComponent,
        Form1118FtcEditComponent,
        IntExpContributedComponent,
        CfcInvestmentAdjEditComponent,
        CfcSplitOnOwnerPercentEditComponent,
        Form1118SyncComponent,
        HtkoConfigComponent,
        K2K3SyncConfigComponent,
        K2SyncComponent,
        BranchTaxCreditableEditComponent,
        BranchTaxCreditableAddComponent,
        BranchAndWithholdCommentComponent,
        BranchtaxSummaryInfoComponent,
        FtCommentsComponent,
        InvestmentValidationComponent,
        SourcingAssetAdjustmentComponent,
        TrackUntrackSchLComponent,
        F1118HpIIAttachSchdComponent,
        F1118AttachSchdComponent,
        MeSicAssignmentComponent,
        ExpenseTransAddEditComponent,
        ExpenseTransAccountDetailsComponent,
        ExpenseTransInfoComponent,
        ExpenseConsolConfigComponent,
        FtcDocumentationComponent,
        AssetRolloverComponent,
        ExamsRolloverComponent,
        Form1118SchdJComponent,
        Form1118SchdKComponent,
        ComponentDefaultsRolloverComponent,
        OtherOverridesDeleteComponent,
        OtherOverridesBatchDeleteComponent,
        TransCatgSyncComponent,
        WithholdTaxSummaryEditComponent,
        AddAttachmentsComponent,
        RemoveAttachmentsComponent,
        K3OverridesComponent,
        AutoTagProcessComponent,
        ActSyncFtcComponent,
        TagSourcingComponent,
        TbbsReclassComponent,
        FtcQar2018Component,
        FtcSourcingSummaryComponent,
        BranchTaxDefaultsEditComponent,
        AttributeBatchComponent,
        AttributeSetUpInfoComponent,
        AddNewTagComponent,
        ComponentDefaultsLockUnlockComponent,
        ComponentDefaultsEditComponent,
        FtcAttributeEditComponent,
        FtcAttributeLockUnlockComponent,
        SyncProcessComponent,
        TransJobsComponent,
        CoaDiagnosticFixComponent],
    exports: [
        F1118SchdCComponent,
        PshipPtrComponent,
        RdSalesAdjustmentComponent,
        RdSalesAdjPercentageEditComponent,
        Config861EditComponent,
        FirEditGtapsAttributesComponent,
        FirFdiiQbaiExcludeAcctComponent,
        BeatTypeConsolAddComponent,
        Form1118ConfigComponent,
        HtkoConfigComponent,
        K2K3SyncConfigComponent,
        K2SyncComponent,
        RdExpContributedComponent,
        Form1118FtcEditComponent,
        IntExpContributedComponent,
        CfcInvestmentAdjEditComponent,
        CfcSplitOnOwnerPercentEditComponent,
        Form1118SyncComponent,
        BranchTaxCreditableEditComponent,
        BranchTaxCreditableAddComponent,
        BranchAndWithholdCommentComponent,
        BranchtaxSummaryInfoComponent,
        FtCommentsComponent,
        InvestmentValidationComponent,
        SourcingAssetAdjustmentComponent,
        TrackUntrackSchLComponent,
        F1118HpIIAttachSchdComponent,
        F1118AttachSchdComponent,
        MeSicAssignmentComponent,
        ExpenseTransAddEditComponent,
        ExpenseTransAccountDetailsComponent,
        ExpenseTransInfoComponent,
        ExpenseConsolConfigComponent,
        FtcDocumentationComponent,
        AssetRolloverComponent,
        ExamsRolloverComponent,
        Form1118SchdJComponent,
        Form1118SchdKComponent,
        ComponentDefaultsRolloverComponent,
        OtherOverridesDeleteComponent,
        OtherOverridesBatchDeleteComponent,
        TransCatgSyncComponent,
        WithholdTaxSummaryEditComponent,
        AddAttachmentsComponent,
        RemoveAttachmentsComponent,
        K3OverridesComponent,
        AutoTagProcessComponent,
        ActSyncFtcComponent,
        TagSourcingComponent,
        TbbsReclassComponent,
        FtcQar2018Component,
        FtcSourcingSummaryComponent,
        BranchTaxDefaultsEditComponent,
        AttributeBatchComponent,
        AttributeSetUpInfoComponent,
        AddNewTagComponent,
        ComponentDefaultsLockUnlockComponent,
        ComponentDefaultsEditComponent,
        FtcAttributeEditComponent,
        FtcAttributeLockUnlockComponent,
        SyncProcessComponent,
        TransJobsComponent,
        CoaDiagnosticFixComponent],
    schemas: [NO_ERRORS_SCHEMA], imports: [
        CommonModule,
        FormsModule,
        AppNgMaterialModule,
        AppNgAppkitModule,
        SharedPipesModule,
        SharedDirectivesModule,
        GtwSearchableSelectModule,
        SharedComponentsModule,
        F1065K2Module], providers: [
        FirEditGtapsAttributesService,
        InvestmentValidationService,
        BranchTaxCreditableAddService,
        FtcDocumentationService,
        AssetRolloverService,
        Form1118SchdJService,
        Form1118SchdKService,
        ComponentDefaultsRolloverService,
        K3OverridesService,
        ActSyncFtcService,
        TagSourcingService,
        TbbsReclassService,
        BranchTaxDefaultsEditService,
        FtcSourcingSummaryService] })
export class FtcModule { }
